<template>
  <div>
    <div v-if="!showText">
      <el-upload
        v-loading="uploadLoading"
        v-show="copyFileList.length < limit"
        :disabled="disabled"
        :drag="drag && copyFileList.length < limit"
        ref="upload"
        style="display: block;"
        action="https://xx.yy.zz"
        :file-list="fileList"
        :limit="limit"
        :auto-upload="false"
        :on-change="onChange"
        :before-upload="beforeUpload"
        :multiple="false"
        :http-request="importListFile"
        :class="{ show_upload_text: !(copyFileList.length < limit) }"
        :show-file-list="false"
        :on-exceed="handleExceed"
      >
        <!-- :before-remove="beforeRemove" -->
        <!-- :on-preview="onPreview()" -->
        <template v-if="drag && copyFileList.length < limit">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            {{ uploadTipText }}，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            {{ tip }}
          </div>
        </template>
        <template v-if="!drag && copyFileList.length < limit">
          <el-button :disabled="disabled" size="small" type="primary">点击上传</el-button>
        </template>
      </el-upload>
      <div v-show="copyFileList.length" class="inline-block">
        <slot name="content">
          <div
            :key="index"
            v-for="(item, index) in copyFileList"
            class="p-0px hover:bg-slate-100 flex items-center text-blue-500"
          >
            <span class="cursor-pointer" @click="onPreview(item)">{{ item.name }}</span>
            <span class="ml-5px cursor-pointer" @click="viewFile(item)">
              <i class="icon-bg-display iconfont"></i>
            </span>
            <span class="ml-5px cursor-pointer" v-if="!disabled" @click="beforeRemove(item)">
              <i class="icon-bg-delete iconfont hover:text-rose-700 hover:shadow"></i>
            </span>
          </div>
        </slot>
      </div>
    </div>
    <div v-else class="inline-block w-full min-h-30px flex items-center">
      <slot name="content">
        <div
          :key="index"
          v-for="(item, index) in copyFileList"
          class="p-0px hover:bg-slate-100 truncate"
        >
          <span
            class="cursor-pointer text-blue-500 underline decoration-1"
            @click="viewFile(item)"
            >{{ item.name }}</span
          >
          <!-- <span class="ml-5px cursor-pointer" @click="viewFile(item)">
            <i class="icon-bg-display iconfont"></i>
          </span> -->
        </div>
      </slot>
    </div>
    <el-image
      v-show="false"
      ref="elImage"
      :src="imgContent"
      :preview-src-list="[imgContent]"
    ></el-image>
  </div>
</template>
<script type="text/babel">
import { FileApi } from '@wiz-api/file-management'

const fileApi = new FileApi()

export default {
  name: 'form-upload',
  model: {
    prop: 'fileIds',
    event: 'change',
  },
  props: {
    // 上传提示文本
    uploadTipText: {
      type: String,
      default: '一次只能上传一个文件',
    },
    // 是否只显示文本
    showText: {
      default: false,
    },
    // 文件数量
    limit: {
      default: 1,
    },
    // 文件大小不超过，单位m，默认100，
    maxSize: {
      type: Number,
      default: 50,
    },
    // 文件总大小不超过，单位m，默认100，
    totalMaxSize: {
      type: Number,
      default: 0,
    },
    // 可上传文件类型;为空数组时可以
    accept: {
      type: Array,
      default: () => {
        return ['pdf', 'jpg', 'png']
        // 图片格式默认前3个
        // 'jpeg', 'gif', 'psd', 'bmp', 'tiff'
      },
    },
    disabled: {
      disabled: false,
    },
    fileIds: {
      default: '',
    },
    // tip: {
    //   type: String,
    //   default: '请上传相关方进场审查资料示例，仅支持上传pdf/jpg/png格式，每次上传不超过100M',
    // },
    // 是否能拖拽，拖拽比较占位置，不拖拽使用按钮上传
    drag: {
      default: true,
    },
  },
  computed: {
    tip() {
      const type =
        this.accept && this.accept.length ? `仅支持上传${this.accept.join('/')}格式,` : ''
      const totalMaxSize = this.totalMaxSize ? `,文件总大小不超过${this.totalMaxSize}M` : ''
      return `${type}每次上传不超过${this.maxSize}M${totalMaxSize}`
    },
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/`
    },
  },
  data() {
    return {
      // fileList上传的时候会改变值，自己写个copyFileList
      fileList: [],
      copyFileList: [],
      // 图片预览信息
      imgContent: null,
      totalSize: 0,
      uploadLoading: false,
      uploadedFileIds: [],
    }
  },
  created() {
    // if (this.fileIds) {
    //   this.fnGetFileList(this.fileIds.split(','))
    //   this.getTotalMaxSize()
    // } else {
    //   this.copyFileList = []
    // }
  },
  watch: {
    fileIds: {
      immediate: true,
      handler(fileIds) {
        if (fileIds) {
          this.fnGetFileList(fileIds.split(','))
          this.getTotalMaxSize()
        } else {
          this.totalSize = 0
          this.fileList = []
          this.copyFileList = []
          this.$emit('exposeFileList', [])
        }
      },
    },
  },
  methods: {
    // 文件超出限制钩子
    handleExceed() {
      this.$message.warning('文件个数超出限制')
    },
    beforeUpload(file) {
      const maxSize = file.size / 1024 / 1024
      const name = file.name
      if (maxSize > this.maxSize) {
        this.$message.warning(`上传文件大小不能超过${this.maxSize}M`)
        return false
      }
      const fileSuffix = name.substring(name.lastIndexOf('.') + 1).toLowerCase()
      if (
        this.accept &&
        this.accept.length > 0 &&
        !this.accept
          .map((i) => {
            return i.toLowerCase()
          })
          .includes(fileSuffix)
      ) {
        this.$message.warning({
          showClose: true,
          message: `上传文件只能是${this.accept.join('/')}`,
          type: 'warning',
        })
        return false
      }
      if (this.totalMaxSize && this.totalSize + maxSize > this.totalMaxSize) {
        this.$message({
          showClose: true,
          message: `文件总大小限制${this.totalMaxSize}M内`,
          type: 'warning',
        })
        return false
      }
      return true
    },
    // 文件总大小
    getTotalMaxSize() {
      const ids = this.fileIds.split(',')
      const list = []
      ids.forEach((id) => {
        list.push(fileApi.getFileInfoVersion(id))
      })
      Promise.all(list).then((res) => {
        this.totalSize =
          res.reduce((pre, item) => {
            const [err, fileRes] = item
            if (!err) {
              pre += fileRes.size
            }
            return pre
          }, 0) /
          1024 /
          1024
      })
    },
    // 获取附件列表
    async fnGetFileList(fileIds) {
      this.fileList = []
      this.copyFileList = []
      const promiseList = []
      fileIds.forEach(async (id) => {
        promiseList.push(fileApi.get(id))
      })
      Promise.all(promiseList)
        .then((fileList) => {
          fileList.forEach((item) => {
            const [err, res] = item
            this.copyFileList.push(res)
            this.fileList.push(res)
            this.$emit('exposeFileList', this.copyFileList)
          })
        })
        .catch()
    },
    // 附件，删除
    async fnDeleteFileReg() {
      const [err, res] = await fileApi.callDelete(this.fileId)
      if (!err) {
        this.$message({
          message: '删除成功',
          type: 'success',
        })
        this.fileList = []
        this.$emit('change', '')
      }
    },
    async importListFile(params) {
      // 上传附件
      this.uploadLoading = true
      const [err, res] = await fileApi.upload({
        files: [params.file],
      })
      this.uploadLoading = false
      if (!err) {
        this.$emit(
          'change',
          [...this.copyFileList, ...res]
            .map((i) => {
              return i.id
            })
            .join(',')
        )
        // this.fnGetFileList(res[0].id)
      }
    },
    onChange(file, fileList) {
      this.fileList = fileList
      this.$refs.upload.submit()
    },
    beforeRemove(file) {
      return this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        callback: (action) => {
          if (action === 'confirm') {
            // this.fnDeleteFileReg(file.id)
            // this.fnDeleteFileReg(this.fileId)
            // 模拟删除
            this.copyFileList = this.copyFileList.filter((i) => {
              return i.id !== file.id
            })
            this.fileList = this.copyFileList
            this.$emit('exposeFileList', this.copyFileList)
            this.$emit(
              'change',
              this.copyFileList
                .map((i) => {
                  return i.id
                })
                .join(',')
            )
          }
        },
      })
    },
    onPreview(file) {
      const type = file.name
        .split('.')
        .at(-1)
        .toLowerCase()
      const typeMap = {
        pdf: 'application/pdf',
      }
      const imageList = ['jpg', 'png', 'jpg', 'jpeg', 'gif', 'psd', 'bmp', 'tiff']
      if (typeMap[type]) {
        window.open(`${this.fileUrl}preview/${file.id}?contentType=application/pdf`)
        return
      }
      if (imageList.indexOf(type) > -1) {
        this.imgContent = `${this.fileUrl}image/${file.id}`
        this.$refs.elImage.clickHandler()
        return
      }
      this.downLoadFile(file)
    },
    // 附件，下载
    async downLoadFile(file) {
      const [err, res] = await fileApi.download(file.id, { returnType: 'Blob' })
      if (!err) {
        this.exportFile(res, file.name)
      }
    },
    // 下载文件
    exportFile(data, name) {
      const blob = new Blob([data], {
        type: 'application/pdf',
      })
      const blobUrl = window.URL.createObjectURL(blob)
      const templink = document.createElement('a')
      templink.style.display = 'none'
      templink.href = blobUrl
      templink.setAttribute('download', `${name}`)
      document.body.appendChild(templink)
      templink.click()
      document.body.removeChild(templink)
      window.URL.revokeObjectURL(blobUrl)
      this.$message({
        type: 'success',
        message: '下载成功!',
      })
    },
    // 查看文件
    async viewFile(file) {
      const strList = file.name.split('.')
      const type = strList[strList.length - 1].toLowerCase()
      const typeMap = {
        pdf: 'application/pdf',
      }
      const imageList = ['jpg', 'png', 'jpg', 'jpeg', 'gif', 'psd', 'bmp', 'tiff']
      if (!typeMap[type] && !(imageList.indexOf(type) > -1)) {
        this.$message.warning('只支持pdf和图片预览')
        return
      }
      if (imageList.indexOf(type) > -1) {
        this.imgContent = `${this.fileUrl}image/${file.id}`
        this.$refs.elImage.clickHandler()
        return
      }
      window.open(`${this.fileUrl}preview/${file.id}?contentType=application/pdf`)
    },
  },
}
</script>

<style lang="scss" scoped>
.show_upload_text {
  ::v-deep {
    .el-upload--text {
      display: none;
    }
  }
}
::v-deep .el-dialog__body {
  padding-top: 0px;
  height: calc(100% - 60px);
}
</style>
